// src/Dashboard/pages/user/Absences/AbsencesPage.jsx

import React from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { FaNotesMedical } from "react-icons/fa";

import DashboardNavigation from "../../DashboardNavigation/DashboardNavigation";
import HeaderTitle from "../../../components/HeaderTitle/HeaderTitle";

import { useUser } from "../../Home/UserContext";
import { getRoleFromRoleId } from "../../../utils/roleHelper";
import useScrollToTop from "../../../hooks/useScollToTop";

import useAbsencesController from "./hooks/useAbsencesController";

import {
  AbsenceSignalForm,
  AbsencesHero,
  AdherentQuickList,
  InfoBanner,
  SelectedAdherentCard,
} from "./components";

export default function AbsencesPage() {
  useScrollToTop();

  const { user } = useUser();
  const userRole = getRoleFromRoleId(user?.role_id);

  const {
    adherents,
    filteredAdherents,
    loading,

    selectedAdherent,
    selectedAdherentId,
    setSelectedAdherentId,

    isBlessed,
    setIsBlessed,

    absenceType,
    setAbsenceType,

    dateReprise,
    setDateReprise,

    motifAbsence,
    setMotifAbsence,

    saving,
    marking,

    search,
    setSearch,

    stats,
    selectedStatus,
    returnDateWarning,

    resetForm,
    handleSubmit,
    handleMarkReturned,
  } = useAbsencesController(user?.userId);

  return (
    <section className="min-h-screen bg-slate-50 text-slate-950 dark:bg-slate-950 dark:text-white">
      <div className="pt-[96px] sm:pt-[120px] lg:pt-[160px]" aria-hidden />

      <main className="mx-auto w-full max-w-7xl px-3 pb-24 sm:px-6 lg:px-8">
        <HeaderTitle
          role="Utilisateur"
          roleId="2"
          title="Signaler une absence"
          subtitle="Gère tes absences, maladies et blessures."
          icon={FaNotesMedical}
          align="left"
          className="mb-4"
        />

        <div className="mb-5 sm:mb-7">
          <DashboardNavigation role={userRole} />
        </div>

        <AbsencesHero stats={stats} loading={loading} />

        <section className="mt-4 overflow-hidden rounded-[2rem] border border-white/70 bg-white/85 shadow-xl shadow-slate-200/70 backdrop-blur dark:border-slate-800/80 dark:bg-slate-900/70 dark:shadow-black/20 sm:mt-6">
          <div className="border-b border-slate-200/70 bg-white/70 px-4 py-4 dark:border-slate-800 dark:bg-slate-900/60 sm:px-5">
            <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
              <div>
                <p className="text-[11px] font-bold uppercase tracking-[0.22em] text-slate-500 dark:text-slate-400">
                  Organisation du club
                </p>

                <h2 className="mt-1 text-xl font-bold text-slate-950 dark:text-white">
                  Absences / Maladies / Blessures
                </h2>
              </div>
            </div>
          </div>

          <div className="p-3 sm:p-5 lg:p-6">
            <InfoBanner />

            <div className="mt-5 grid grid-cols-1 gap-5 lg:grid-cols-[360px_minmax(0,1fr)]">
              <AdherentQuickList
                adherents={filteredAdherents}
                totalAdherents={adherents.length}
                selectedAdherentId={selectedAdherentId}
                onSelect={(id) => setSelectedAdherentId(String(id))}
                search={search}
                setSearch={setSearch}
                loading={loading}
              />

              <div className="space-y-5">
                <SelectedAdherentCard
                  adherent={selectedAdherent}
                  onMarkReturned={handleMarkReturned}
                  busy={marking}
                />

                <AbsenceSignalForm
                  selectedAdherent={selectedAdherent}
                  selectedStatus={selectedStatus}
                  absenceType={absenceType}
                  setAbsenceType={setAbsenceType}
                  isBlessed={isBlessed}
                  setIsBlessed={setIsBlessed}
                  dateReprise={dateReprise}
                  setDateReprise={setDateReprise}
                  motifAbsence={motifAbsence}
                  setMotifAbsence={setMotifAbsence}
                  returnDateWarning={returnDateWarning}
                  saving={saving}
                  onSubmit={handleSubmit}
                  onReset={resetForm}
                />
              </div>
            </div>
          </div>
        </section>
      </main>

      <ToastContainer position="bottom-center" />
    </section>
  );
}